module.exports = __webpack_public_path__ + "img/device_i.139aa520.png";